import { render, staticRenderFns } from "./StockLineLotAvailability.vue?vue&type=template&id=2b996086&scoped=true"
import script from "./StockLineLotAvailability.vue?vue&type=script&lang=js"
export * from "./StockLineLotAvailability.vue?vue&type=script&lang=js"
import style0 from "./StockLineLotAvailability.vue?vue&type=style&index=0&id=2b996086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b996086",
  null
  
)

export default component.exports